import { ADD_BRAND_PRODUCT_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

import addBrandProduct from 'root/src/client/logic/tableItem/thunks/addBrandProduct'
import addBrandProductOnSuccess from 'root/src/client/logic/tableItem/thunks/addBrandProductOnSuccess'

export default {
	[ADD_BRAND_PRODUCT_FORM_MODULE_ID]: [
		{
			action: addBrandProduct,
			onSuccess: addBrandProductOnSuccess,
		},
	],
}
